import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";


export const WithdrawalService = {
    /**
     * [SKRILL]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.accountID
     */
    Skrill(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.Skrill, requestOptions);
    },
    /**
     * [NETELLER]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.accountID
     */
    Neteller(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.Neteller, requestOptions);
    },
    /**
     * [UNIONPAY]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.beneficiaryName
     * @param {string} data.beneficiaryAccountNumber
     * @param {string} data.bankName
     * @param {string} data.bankBranch
     * @param {string} data.province
     * @param {string} data.city
     */
    UnionPay(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.UnionPay, requestOptions);
    },
    /**
     * [ZOTAPAY]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.beneficiaryName
     * @param {string} data.beneficiaryAccountNumber
     * @param {string} data.bankName
     * @param {string} data.bankCurrency
     */
    ZotaPay(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.ZotaPay, requestOptions);
    },
    /**
     * [BANKACCOUNT]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.bankAccount
     */
    BankAccount(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.BankAccount, requestOptions);
    },
    /**
     * [CANCEL]
     * @param {object} data
     * @param {string} data.transactionId 
     */
    Cancel(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.Cancel, requestOptions);
    },
      /**
     * [BTCPAY]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.address
     */
    BtcPay(data){
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.BtcPay, requestOptions);
    },
       /**
     * [TPAY]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.address
     */
        TPay(data){
            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }
    
            return WithdrawalService.Common.Fetch(Config.service.withdrawal.TPay, requestOptions);
        },
        
       /**
     * [TPAYTRC20]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.address
     */
        TPayTRC20(data){
            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }
    
            return WithdrawalService.Common.Fetch(Config.service.withdrawal.TPayTRC20, requestOptions);
        },
          /**
     * [FLASHPAY]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     */
    FlashPay(data){
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.FlashPay, requestOptions);
    },
     /**
     * [VERIFICATION]
     * @param {object} data
     * @param {string} data.token
     */
    Verification(data){
        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.Verification, requestOptions);
    },
    /**
     * [UNIPAYMENT]
     * @param {object} data
     * @param {number} data.login
     * @param {number} data.amount
     * @param {string} data.currency
     * @param {string} data.transactionId
     */
    Unipayment(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return WithdrawalService.Common.Fetch(Config.service.withdrawal.Unipayment, requestOptions);
    },
    /**
    * [COMMON]
    * @function Fetch
    */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {
                        UserService.Logout();
                        window.location.reload();
                    }
                    else {
                        throw new Error();
                    }
                }).then((json) => {

                    return json;

                }).catch(function () {
                    return false;
                });

        }
    }
}

